
import { Dialog, DialogContent } from "@/components/ui/dialog"
import { PaymentDialog } from "./PaymentDialog"
import { FormStepWrapper } from "./form/FormStepWrapper"
import { FormNavigation } from "./form/FormNavigation"
import { FormProgress } from "./form/FormProgress"
import { FormHint } from "./form/FormHint"
import { FormStepRenderer } from "./form/FormStepRenderer"
import { useMultiStepForm } from "@/hooks/useMultiStepForm"

interface MultiStepFormProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  initialDeliveryMethod?: string | null
}

export function MultiStepForm({ open, onOpenChange, initialDeliveryMethod }: MultiStepFormProps) {
  const {
    step,
    showPayment,
    setShowPayment,
    showErrors,
    formData,
    handleInputChange,
    handleNext,
    handleBack,
    validateCurrentStep,
    isEmailDelivery
  } = useMultiStepForm(initialDeliveryMethod)

  return (
    <>
      <Dialog open={open && !showPayment} onOpenChange={onOpenChange}>
        <DialogContent 
          className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto" 
          onPointerDownOutside={(e) => e.preventDefault()}
        >
          <FormProgress currentStep={step} totalSteps={5} showPayment={showPayment} />
          <FormHint step={step} />
          <FormStepWrapper>
            <FormStepRenderer
              step={step}
              isEmailDelivery={isEmailDelivery}
              formData={formData}
              handleInputChange={handleInputChange}
              showErrors={showErrors}
            />
            <FormNavigation
              step={step}
              isValid={validateCurrentStep()}
              onBack={handleBack}
              onNext={handleNext}
            />
          </FormStepWrapper>
        </DialogContent>
      </Dialog>
      <PaymentDialog 
        open={showPayment} 
        onOpenChange={(open) => {
          setShowPayment(open)
          if (!open) {
            onOpenChange(false)
          }
        }}
        formData={formData}
        initialDeliveryMethod={initialDeliveryMethod}
      />
    </>
  )
}
